class Effects {
  constructor(effects = [], asyncEffects = []) {
    this.effects = effects;
    this.asyncEffects = asyncEffects;
  }
  add(effect) {
    this.effects.push(effect);
  }
  addAsync(effect) {
    this.asyncEffects.push(effect);
  }
  async run() {
    while (this.effects.length > 0) {
      this.effects.shift()?.();
    }
    while (this.asyncEffects.length > 0) {
      const asyncEffects = this.asyncEffects.slice();
      this.asyncEffects = [];
      await Promise.all(asyncEffects.map((effect) => effect()));
    }
  }
}
export {
  Effects
};
//# sourceMappingURL=effects.js.map